// extracted by mini-css-extract-plugin
export default {"root":"style_root__B1yS7","label":"style_label__fzsKn"};